import { useGlobalStore } from '@/frontend/store/GlobalStore';
import { FusaReply } from '@/types/replyTypes';
import { FusaToast, FusaToastType } from './types';
import { I18n } from '@/i18n/I18n';
import { FusaError } from '@/errors/fusaError';

export function checkForToast(jsonResponse: FusaReply) {
  const { addToast } = useGlobalStore.getState();
  if (jsonResponse.toast) addToast(jsonResponse.toast);

  jsonResponse.errors?.forEach((error: FusaError) => {
    if (!error.hideToast) {
      const toast: FusaToast = {
        header: I18n.get('error'),
        message: error.message,
        link: error.link,
        linkText: error.linkText,
        type: FusaToastType.ERROR,
      };
      addToast(toast);
    }
  });
}